module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_250_500.c6cbe981.png";